export var UserState;
(function (UserState) {
    UserState["ACTIVE"] = "ACTIVE";
    UserState["INVITED"] = "INVITED";
    UserState["ARCHIVED"] = "ARCHIVED";
    UserState["DELETED"] = "DELETED";
})(UserState || (UserState = {}));
//# sourceMappingURL=index.js.map